if (navigator.share) {
  const shareButtons = document.querySelectorAll('.product_share_button');

  shareButtons.forEach((shareButton) => {
    shareButton.addEventListener('click', () => {
      // const title = document.querySelector('.product-meta__vendor').textContent;
      // const subtitle = document.querySelector('.product-meta__title').textContent;
      const url = window.location.href;
      navigator.share({
        // title: title,
        // text: subtitle,
        url: url
      })
        .then(() => console.log('Sharing succeeded.'))
        .catch((error) => console.log('Sharing failed:', error));
    });
  });
} else {
  const viewBtn = document.querySelector(".view-modal");
  const popup = document.querySelector(".popup");
  const close = popup.querySelector(".close");
  const field = popup.querySelector(".field");
  const input = field.querySelector("input");
  const copy = field.querySelector("button");

  viewBtn.onclick = () => {
    popup.classList.toggle("show");
  };

  close.onclick = () => {
    viewBtn.click();
  };

  copy.onclick = () => {
    input.select(); // Select input value
    if (document.execCommand("copy")) { // If the selected text is copied
      field.classList.add("active");
      copy.innerText = "Copied";
      setTimeout(() => {
        window.getSelection().removeAllRanges(); // Remove selection from the document
        field.classList.remove("active");
        copy.innerText = "Copy";
      }, 3000);
    }
  };
}
const shareUrlInput = document.getElementById('share-url');
let currentUrl = window.location.href;

function updateShareUrl() {
  const productUrl = window.location.href;
  if (productUrl !== currentUrl || shareUrlInput.value === '') {
    shareUrlInput.value = productUrl;
    currentUrl = productUrl;
  }
}

// Check for URL changes every 500 milliseconds
setInterval(updateShareUrl, 500);

// Initial update of the input value
updateShareUrl();